// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetOfferCalendarRequest, TGetOfferCalendarModel, IMappers, TGetOfferCalendarResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV2GetOfferCalendarResponse } from '../../entities/response/V2GetOfferCalendarResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetOfferCalendarModel(parameters: TGetOfferCalendarRequest): TGetOfferCalendarModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'dailyrent',
    pathApi: '/v2/get-offer-calendar/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetOfferCalendarOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetOfferCalendarRequest;
}

export async function fetchGetOfferCalendar<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOfferCalendarOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetOfferCalendarResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetOfferCalendarModel(parameters),
    config,
  )) as FetchResponse<TGetOfferCalendarResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV2GetOfferCalendarResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetOfferCalendarResponse>;
}
